import { RadioGroup } from '@acpaas-ui/react-components';
import { useRef } from 'react';
import { v4 as uuid } from 'uuid';

const Radio = ({ onChange, ...props }) => {
  const id = useRef(uuid()).current;

  return (
    <RadioGroup
      id={`radio-${id}`}
      {...props}
      onChange={(event) => onChange(event.target.value)}
      inline={false}
    ></RadioGroup>
  );
};

export default Radio;
